// usePlatformFees.js
import { useEffect, useState } from "react";
import api from "../axiosConfig";

export default function usePlatformFees() {
  const [fees, setFees] = useState({
    serviceFee: 0,
    deliveryFee: 0,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let mounted = true;

    const fetchFees = async () => {
      try {
        // ✅ ROUTE PUBLIQUE CORRECTE
        const res = await api.get("/platform/settings");

        if (!mounted) return;

        setFees({
          serviceFee: Number(res.data.serviceFee) || 0,
          deliveryFee: Number(res.data.deliveryFee) || 0,
          loading: false,
          error: null,
        });
      } catch (err) {
        console.error("❌ usePlatformFees:", err);

        if (!mounted) return;

        setFees({
          serviceFee: 0,
          deliveryFee: 0,
          loading: false,
          error: "Impossible de charger les frais",
        });
      }
    };

    fetchFees();

    return () => {
      mounted = false;
    };
  }, []);

  return fees;
}